module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassicWeb-Light-57649eb1842678d0372db90044f40fbe.woff";